<template>
  <v-layout v-if="!isMobile" id="containerTableNavigation" align-end justify-start>
    <v-flex
      v-for="item in items"
      :key="item.value"
      shrink
      class="table-navigation__tab hwayzTab-background"
      :class="{'table-navigation__tab--active': active === item.value}"
      :style="{'width': `${(isMobile?100:60) / items.length}%`}"
      @click="setActive(item.value)"
    >
      <div class="tab">
        <v-icon
          v-if="item.icon"
          class="table-navigation__tab-icon"
          :class="{
            'gold--text': active === item.value,
            'white--text': active !== item.value
          }"
        >
          {{ item.icon }}
        </v-icon>
        <template v-else>
          <svg-icon
            :name="item.svgIcon"
            class="table-navigation__tab-icon"
            :height="item.size"
            :width="item.size"
          />
        </template>
        <span class="table-navigation__tab-label">{{ item.text }}</span>
      </div>
    </v-flex>
  </v-layout>
  <div v-else>
    <v-tabs
      v-model="active"
      :centered="true"
      :grow="true"
      slider-color="#232C43"
    >
      <v-tab v-for="field in items" :key="field.value">
        {{ field.text }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import colors from '../../../scss/_colors.scss'

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      active: 0,
      colors: colors
    }
  },

  computed: {
    ...mapState('common', ['isMobile', 'selectedFavoritesTab'])
  },

  watch: {
    active() {
      this.setSelectedFavoritesTab(this.active)
      this.$emit('tab-changed', this.active)
    }
  },
  created() {
    if (this.selectedFavoritesTab === 0) {
      this.active = 0
    } else {
      this.active = this.selectedFavoritesTab
    }
  },
  methods: {
    ...mapActions('common', ['setSelectedFavoritesTab']),
    setActive(val) {
      this.active = val
    }
  }
}
</script>

<style lang="sass" scoped>
#containerTableNavigation
  @media only screen and (max-width: 600px)
    margin: 0
    position: fixed
    left: 2px
    width: 100vw
    z-index: 3

.table-navigation__tab
  cursor: pointer
  text-align: center
  font-size: $hwayzFont1rem4
  border-radius: 0.9rem 0.9rem 0 0
  margin-right: 1rem
  margin-bottom: 3px
  /* Make this size relative */
  width: 20%
  min-width: 16rem
  color: white
  height: 5rem
  padding-top: 1.2rem
  padding-bottom: 1rem
  display: table
  -webkit-box-shadow: 0.2rem -0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  -moz-box-shadow: 0.2rem -0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  box-shadow: 0.2rem -0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)

  @media only screen and (max-width: 600px)
    background-color: #ddd
    border-radius: 0
    margin: 0
    color: #000
    i, svg
      display: none

.table-navigation__tab--active
  background-color: white
  color: $hwayzBrandGold
  padding-bottom: 1rem
  @media only screen and (max-width: 600px)
    background-color: #ddd
    color: $hwayzBlue

.tab
  vertical-align: middle
  display: table-cell

.table-navigation__tab-icon
  color: inherit
  font-size: 28px
  margin-right: 1rem
  vertical-align: middle
</style>
